import { render } from "./MainProductChatbot.vue?vue&type=template&id=db3bde30&scoped=true"
import script from "./MainProductChatbot.vue?vue&type=script&lang=js"
export * from "./MainProductChatbot.vue?vue&type=script&lang=js"

import "./MainProductChatbot.vue?vue&type=style&index=0&id=db3bde30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3bde30"]])

export default __exports__